<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page">
      <div class="formgrid grid">
        <div class="field col-12 md:col-10">
          <!-- <label>Anno</label> -->
          <Calendar class="w-full" v-model="year" dateFormat="yy" view="year" :showIcon="true" />
          <div v-show="validationErrors.year && submitted" class="p-error">Campo richiesto.</div>
        </div>
        <div class="field col-12 md:col-2 flex align-items-end">
          <Button @click="getProspetto" class="w-full" label="Genera Prospetto" />
        </div>
      </div>
    

    <DataTable v-if="displayTable" :value="items" v-model:selection="selectedItems" :filters="filters" responsiveLayout="scroll">
        <template #header>
          <div class="flex justify-content-between flex-wrap">
              <div class="flex align-items-center justify-content-center mb-2">
                <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                </span>
              </div>
          </div>
        </template>
        <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
        <Column field="name" header="Nome" :sortable="true"></Column>
        <Column field="codfis" header="C.Fiscale" :sortable="true"></Column>
        <Column field="comune" header="Comune" :sortable="true"></Column>
    </DataTable>

    <div v-if="!displayTable">
       <Accordion class="mb-3">
        <AccordionTab header="Opzioni download">
          <div class="grid">
            <div class="field col-12 md:col-5">
              <div class="wrap">
                <h6 class="ml-2">Prospetto:</h6>
                <div class="field-radiobutton mt-2">
                  <RadioButton value="multiple" v-model="optionDownload.type_sheet" class="mx-2" />
                  <label>Rapp/Cliente per foglio</label>
                  <RadioButton value="single" v-model="optionDownload.type_sheet" class="mx-2" />
                  <label>Unico foglio</label>
                </div>
              </div>
            </div>
            <div class="field col-12 md:col-5">
              <div class="wrap">
                <h6 class="ml-2">Raggruppa:</h6>
                <div class="field-radiobutton mt-2">
                  <RadioButton value="competenza" v-model="optionDownload.type_group" class="mx-2" />
                  <label>Per competenza</label>
                  <RadioButton value="cliente" v-model="optionDownload.type_group" class="mx-2" />
                  <label>Per cliente</label>
                </div>
              </div>
            </div>
            <div class="field col-12 md:col-2 flex align-items-end">
              <Button @click="downloadProspetto" class="w-full p-button-secondary" label="Scarica Prospetto" />
            </div>
          </div>
        </AccordionTab>
      </Accordion>

      <InputText  @keyup="onGlobalSearch" class="mb-1 w-3" v-model="searchString" type="text" placeholder="Cerca per nome rappresentante..."/>



        <!-- <TabPanel v-for="(tab, nameRapp) in tabsRapp" :key="nameRapp" :header="nameRapp">
            <Accordion :multiple="true" lazy>
              <AccordionTab v-for="(elements, month, index) in tab" :key="index" >
                  <template #header>
                    <div class="flex justify-content-between flex-wrap w-full">
                      <div class="flex align-items-center justify-content-left flex-column">
                        <div> <i class="pi pi-calendar mx-2"></i> {{moment(month, 'YYYY-MM-DD')}}</div>
                      </div>
                    </div>
                  </template>
              </AccordionTab> 
          </Accordion>
        </TabPanel> -->

      <TabView lazy>
        <TabPanel v-for="(tabs, nameRapp) in tabsRapp" :key="nameRapp" :header="nameRapp">
            <Accordion :multiple="true">
              <AccordionTab v-for="(tab, year) in tabs" :key="year" :header="year">
                <Accordion :multiple="true">
              <AccordionTab v-for="(elements, month, index) in tab" :key="index" >
                  <template #header>
                    <div class="flex justify-content-between flex-wrap w-full">
                      <div class="flex align-items-center justify-content-left flex-column">
                        <div> <i class="pi pi-calendar mx-2"></i> {{moment(month, 'YYYY-MM-DD').isValid() ? moment(month).locale('it').format('MMMM').toUpperCase() : month}}</div>
                      <div> <small class="text-500"> {{tab[month].invoices.length}} fatture</small> </div>
                      </div>
                      <i></i>
                      <div class="text-left">
                        <small class="price"> <span class="text-500">Totale Ciclo:</span>  {{formatCurrency(elements.tot_ciclo)}}</small> -
                        <small class="price"> <span class="text-500">Totale Fatture:</span>  {{formatCurrency(elements.tot_fatture)}}</small> -
                        <small class="price"> <span class="text-500">Totale Pagato: </span> {{formatCurrency(elements.tot_pagato)}}</small> -
                        <small class="price"> <span class="text-500">Totale Saldo:</span>  {{formatCurrency(elements.tot_saldo)}}</small> -
                        <small class="price"> <span class="text-500">Totale Contabili:</span>  {{formatCurrency(elements.tot_contabili)}}</small>
                      </div>
                    </div>
                  </template>

                <DataTable key="numero" :ref="`dt_${nameRapp}_${month}`" :value="elements.invoices" @row-dblclick="openDetailFattura" :paginator="true" :rows="20" :filters="filters"
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
                  currentPageReportTemplate="{first} a {last} di {totalRecords}">
                  <template #header>
                    <div class="flex justify-content-between flex-wrap">
                        <!-- <div class="flex align-items-center justify-content-center mb-2">
                          <span class="p-input-icon-left">
                              <i class="pi pi-search" />
                              <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                          </span>
                        </div> -->
                        <div class="flex align-items-center justify-content-center">
                          <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV(nameRapp,month)" class="p-button-secondary" />
                        </div>
                    </div>
                  </template>
                  <template #empty>
                      <div class="text-center">Nessun dato trovato.</div>
                  </template>
                  <Column field="numero" header="N. Fattura" :sortable="true" />
                  <Column field="periodo" header="Periodo" :sortable="true" />
                  <Column field="" header="Fornitura" :sortable="true">
                    <template #body="{data}">
                      <div v-if="data.pod">
                        {{data.pod}}
                      </div>
                      <div v-else>
                        {{data.pdr}}
                      </div>
                    </template>
                  </Column>
                  <Column field="mese_fatturazione" header="Mese Fatturazione" :sortable="true">
                    <template #body="{data}">
                      {{moment(data.mese_fatturazione).format('DD-MM-YYYY')}}     
                    </template>
                  </Column>
                  <Column field="data_emissione" header="Data Emissione" :sortable="true">
                    <template #body="{data}">
                      {{moment(data.data_emissione).format('DD-MM-YYYY')}}     
                    </template>
                  </Column>
                  <Column field="data_scadenza" header="Data Scadenza" :sortable="true">
                    <template #body="{data}">
                        {{moment(data.data_scadenza).format('DD-MM-YYYY')}}     
                    </template>
                  </Column>
                  <Column field="totale_fattura" header="Totale Fattura" :sortable="true" />
                  <Column field="pagato" header="Totale Pagato" :sortable="true" />
                  <Column field="saldo" header="Totale Saldo" :sortable="true" />
                  <Column field="importo_contabile" header="Importo Contabile" :sortable="true" />
                  <Column field="tipo_contabile" header="Tipo Contabile" :sortable="true" />
                  <Column field="type_pay" header="Tipo Pagamento" :sortable="true" />
                  <Column field="cliente" header="Cliente" :sortable="true" />
                  <Column field="codfis" header="C.Fiscale" :sortable="true" />
                  <Column field="piva" header="P.Iva" :sortable="true" />
                  <Column field="rappresentante" header="Rappresentante" :sortable="true" />
                  <Column field="data_inizio_fornitura" header="Data Inizio" :sortable="true" />
                  <Column field="data_fine_fornitura" header="Data Fine" :sortable="true" />
                  <Column field="stato_fornitura" header="Stato Interno" :sortable="true" />
                  <Column field="ultima_pratica" header="Ultima Pratica" :sortable="true" />
                  <Column field="agente" header="Agente" :sortable="true" />
                  <Column header="" :exportable="false" style="min-width:24rem">
                    <template #body="{data}">
                         <Button  label="Da sospendere" class="p-button p-button-warning mr-3" @click="createPreSuspensionOrReactivation(data, 'sospensioni')" />
                         <Button  label="Da riattivare" class="p-button p-button-primary" @click="createPreSuspensionOrReactivation(data, 'riattivazioni')" />
                    </template>
                  </Column>
                </DataTable>
                
              </AccordionTab> 
            </Accordion>
              </AccordionTab>
            </Accordion>
            
        </TabPanel>
      </TabView>
    </div>

  </div>

</template>

<script>

import { ref, getCurrentInstance } from 'vue';
import Service from '@/services/ask-operation/operation-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";
import moment from 'moment';

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'rappresentanti-multi-prospetto-ciclo-pagamenti'}
    const loader = ref(false)
    const toast = useToast();

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const dt = ref();
    const items = ref(props.data.itemsRapp)
    const itemsAgent = ref(props.data.itemsAgent)
    const year = ref()
    const selectedItems = ref(items.value);
    const tabsRapp = ref([]);
    const originalTabsRapp = ref([]);
    const displayTable = ref(true);
    const optionDownload = ref({
      type_sheet: 'multiple',
      type_group: 'competenza',
    });
    const searchString = ref('')
    const validationErrors = ref({})
    const submitted = ref(true)
    
      
    const getProspetto = () => {
      toast.removeGroup(page.name);
      if (validateForm()) {
        
        if (selectedItems.value.length > 0) {
          loader.value = true

          let d = year.value ? moment(year.value).format('YYYY') : null

          service.getMultiProspettoCicloPagamenti(selectedItems.value, d, itemsAgent.value)
          .then((res) => {
            tabsRapp.value = res.items
            originalTabsRapp.value = res.items
            displayTable.value = false
          })
          .finally(()=>{
            loader.value = false
          })
        } else {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Non hai selezionato nessun elemento', group: page.name});
        }
      }
    }

    const onGlobalSearch = () => {
      tabsRapp.value = {...originalTabsRapp.value}
      if (searchString.value.length > 0) {
        for (const nameRapp of Object.keys(originalTabsRapp.value)) {
          if (!nameRapp.includes(searchString.value.toUpperCase())) {
            delete  tabsRapp.value[nameRapp]
          }
        }
      }
    }

    const downloadProspetto = () => {
      loader.value = true
      console.log(originalTabsRapp.value, optionDownload.value);
      service.downloadMultiProspettoCicloPagamenti(originalTabsRapp.value, optionDownload.value)
      .finally(()=>{
        loader.value = false
      })
    }

    const createPreSuspensionOrReactivation = (data, type) => {
      
      loader.value = true
      let obj = {}
      obj.type = type
      if (data.pod) {
        obj.cod_pod = data.id_fornitura
      } else {
        obj.cod_pdr = data.id_fornitura
      }

      service.createPreSuspensionOrReactivation(obj)
      .finally(()=>{
        loader.value = false
      })
    }


    const validateForm = () => {

      // if (!year.value) {
      //     validationErrors.value['year'] = true;
      // } else {
      //   delete validationErrors.value['year'];
      // }

      return !Object.keys(validationErrors.value).length;
    }

    const formatCurrency = (value) => {
      return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
    }

    const openDetailFattura = (event) => {
      let {data} = event
      if ('numero' in data) {
        window.open(`/ask/clienti/fatture/${data.numero}/dettagli`, '_blank')
      } 
    }

    const exportCSV = (nameRapp, month) => {
      self.refs[`dt_${nameRapp}_${month}`].exportCSV()
    };

    return {
      moment,
      dt,
      page,
      filters,
      items,
      itemsAgent,
      selectedItems,
      tabsRapp,
      originalTabsRapp,
      displayTable,
      searchString,
      year,
      loader,
      getProspetto,
      downloadProspetto,
      formatCurrency,
      openDetailFattura,
      onGlobalSearch,
      optionDownload,
      createPreSuspensionOrReactivation,
      exportCSV,
      validationErrors,
      submitted,
      
    }
  }
}


</script>


<style scoped>
.wrap {
  padding: 10px;
  border: 1px solid rgba(51, 51, 51, 0.064);
}
</style>
